import React, { useState, useEffect } from "react";
import BackBtn from "../../btncomponent/BackBtn";
import ShowImage from "../ShowImage";
import { isAuthenticated } from "../../auth";
import Swal from "sweetalert2";
import { Redirect } from "react-router-dom";
import Axios from "axios";

const Book = (props) => {
  const [room, setRoom] = useState({});

  const [values, setValues] = useState({
    name: "",
    email: "",
    phone: "",
    user: isAuthenticated().user._id,
    college: "",
    error: "",
    loading: false,
    success: false,
    pay: false,
    paymentId: "",
    orderId: "",
    paymentalert: false,
    roomname: "",
    roomimgid: "",
    roomdesc: "",
  });

  const {
    name,
    email,
    phone,
    college,
    loading,
    error,
    success,
    pay,
    paymentId,
    orderId,
    paymentalert,
    roomname,
    roomimgid,
    roomdesc,
  } = values;

  const { user, token } = isAuthenticated();

  useEffect(() => {
    const bookid = props.match.params.bookid;
    setValues({ loading: true });
    const fetchdata = () => {
      fetch(`${process.env.REACT_APP_API_URL}/home/${bookid}`, {
        method: "GET",
      })
        .then((res) => {
          return res.json();
        })
        .catch((err) => {
          console.log(err);
        })
        .then((data) => {
          if (data.error) {
            console.log(data.error);
          } else {
            setRoom(data);
            setValues({
              loading: false,
              roomname: data.name,
              roomimgid: data._id,
              roomdesc: data.description,
            });
          }
        });
    };
    fetchdata();
  }, [props]);

  const handleChange = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value, error: "" });
  };

  const clickSubmit = (e) => {
    setValues({ ...values, loading: true });
    e.preventDefault();
    fetch(`${process.env.REACT_APP_API_URL}/create/new/roombook/${user._id}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        name,
        email,
        user,
        phone,
        college,
        paymentId,
        orderId,
        roomimgid,
        roomdesc,
        roomname,
      }),
    })
      .then((res) => {
        return res.json();
      })
      .catch((err) => {
        console.log(err);
      })
      .then((data) => {
        if (data.error) {
          setValues({ ...values, error: data.error, success: false });
        } else {
          // Swal.fire({
          //   title: " successfully",
          // });
          setValues({
            ...values,
            name: "",
            email: "",
            phone: "",
            college: "",
            loading: false,
            success: true,
          });
        }
      });
  };

  const showpaymentalert = () => (
    <div style={{ display: paymentalert ? "" : "none" }}>
      <div
        className="alert alert-success alert-dismissible fade show"
        role="alert"
      >
        Payment successful, press continue to complete your booking
        <button
          type="button"
          className="close"
          data-dismiss="alert"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
  );

  const showloading = () =>
    loading && (
      <div className="d-flex justify-content-center">
        <div className="spinner-border spinner-border-sm" role="status">
          <span className="sr-only">Loading...</span>
        </div>
        <div className="spinner-grow spinner-grow-sm" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );

  const showContinue = () =>
    pay && (
      <button className="btn btn-success">
        continue <i className="fas fa-long-arrow-alt-right"></i>
      </button>
    );

  const showPay = () => {
    return pay ? (
      ""
    ) : (
      <button
        className="btn text-dark"
        onClick={paymentHandler}
        style={{ backgroundColor: "#FCCE01", borderRadius: "10" }}
      >
        Pay Now
      </button>
    );
  };
  const showError = () => (
    <div style={{ display: error ? "" : "none" }}>
      <div
        className="alert alert-danger alert-dismissible fade show"
        role="alert"
      >
        {error}
        <button
          type="button"
          className="close"
          data-dismiss="alert"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
  );

  if (success) {
    return <Redirect to={`/mybooking/${isAuthenticated().user._id}`} />;
  }

  const paymentHandler = async (e) => {
    e.preventDefault();
    const orderUrl = `${process.env.REACT_APP_API_URL}/order/${room.price}`;
    const response = await Axios.get(orderUrl);
    const { data } = response;

    const options = {
      key: process.env.RAZOR_PAY_TEST_KEY,
      name: `${room.name}`,
      description: `${room.description}`,
      order_id: data.id,
      handler: async (response) => {
        try {
          const paymentId = response.razorpay_payment_id;
          const orderId = response.razorpay_order_id;
          const sign = response.razorpay_signature;
          // const url = `${process.env.REACT_APP_API_URL}/capture/${paymentId}`;
          // const captureResponse = await Axios.post(url, {});
          // console.log(captureResponse.data);
          console.log(orderId);
          console.log(sign);
          setValues({
            ...values,
            pay: true,
            paymentId,
            orderId,
            paymentalert: true,
          });
        } catch (err) {
          console.log(err);
        }
      },

      theme: {
        color: "#686CFD",
      },
    };
    const rzp1 = new window.Razorpay(options);
    rzp1.open();
  };

  return (
    <div
    // style={{
    //   position: "fixed",
    //   top: 0,
    //   bottom: 0,
    //   left: 0,
    //   right: 0,
    //   backgroundColor: "#262626",
    //   padding: 50,
    // }}
    >
      <div className="container mt-5 mb-5">
        <div className="bg-info text-center text-white p-1">
          <h6>
            {" "}
            <i className="fas fa-home"></i> Book Now{" "}
          </h6>
          <p> Please confirm your contact details below.</p>
        </div>
        <br />
        <BackBtn location="/" />
        <br />
        {showloading()}
        {showError()}

        <div className="row">
          <div className="col-sm-3 ">
            <ShowImage url="home" item={room} />
            <h4>{room.name}</h4>
            <p>{room.description}</p>
            <p> Rent: {room.price}/Month</p>
          </div>

          <div className="col-sm-5">
            <form onSubmit={clickSubmit}>
              <div className="mb-3">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Type name"
                  onChange={handleChange("name")}
                  value={name || ""}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Email address</label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="name@example.com"
                  onChange={handleChange("email")}
                  value={email || ""}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Phone no.</label>
                <input
                  type="number"
                  className="form-control"
                  onChange={handleChange("phone")}
                  value={phone || ""}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">College Name</label>
                <input
                  type="text"
                  className="form-control"
                  onChange={handleChange("college")}
                  value={college || ""}
                  required
                />
              </div>
              <br />

              <div
                className={"modal fade" + (pay ? " show d-block" : " d-none")}
                tabIndex="-1"
                role="dialog"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-body">
                      {showpaymentalert()}
                      {showContinue()}
                    </div>
                  </div>
                </div>
              </div>

              {showPay()}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Book;
